import React from 'react';
import { navigate } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  boxShadow,
  fontSize,
  minBreakpointQuery,
  standardColours,
} from '../styles';
import { Link } from './ui';
import { buildUrl } from '../utils';
import rightArrow from '../images/right-arrow.svg';

const StyledBannerCta = styled.article`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding: 30px;
  background-color: ${standardColours.white};
  ${boxShadow()};
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
`;

const StyledContent = styled.div``;

const StyledHeading = styled.h2`
  ${fontSize(20)};

  ${minBreakpointQuery.small`
    ${fontSize(22)};
  `}

  ${minBreakpointQuery.xxlarge`
    ${fontSize(24)};
  `}
`;

const StyledText = styled.p`
  margin-top: 12px;
  ${fontSize(15)};
  line-height: 1.4;

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}
`;

const StyledLink = styled(Link)`
  position: relative;
  margin-top: 12px;
  padding-right: 20px;
  ${fontSize(15)};
  text-decoration: underline;
  text-underline-offset: 2px;

  ${minBreakpointQuery.small`
    ${fontSize(16)};
  `}

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    height: 12px;
    width: 12px;
    background-color: ${standardColours.black};
    mask-image: url(${rightArrow});
    transform: translateY(-40%);
  }
`;

const StyledImageWrapper = styled.div`
  display: flex;
`;

const StyledImage = styled(GatsbyImage)`
  margin-left: auto;
`;

const BannerCta = ({ heading, text, link, image }) => (
  <StyledBannerCta
    onClick={() => navigate(buildUrl(link.pageUrl.slug, link.pageUrl))}
  >
    <StyledContent>
      <StyledHeading>{heading}</StyledHeading>
      <StyledText>{text}</StyledText>
      <StyledLink to={link.pageUrl}>{link.text}</StyledLink>
    </StyledContent>
    <StyledImageWrapper>
      <StyledImage
        image={image.gatsbyImageData}
        alt={image.alt}
        loading="eager"
        fetchPriority="high"
      />
    </StyledImageWrapper>
  </StyledBannerCta>
);

export default BannerCta;
